<highcharts-chart
  [Highcharts]="Highcharts"
  [options]="chartOptions"
  class="highcharts-light block w-12 h-12"
  (chartInstance)="setChart($event)">
</highcharts-chart>

